import React from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import { cn } from '@bem-react/classname';
import { fetchDeleteVariable } from 'store/action/variables';

import { Button, Subtitle, Title } from 'components';

import './DeleteVariable.scss';

const CnDeleteVariable = cn('deleteVariable');

export const DeleteVariable: React.FC = () => {
    const location = useLocation();
    const state = location.state as {
        id: string;
        name: string;
    };

    const navigate = useNavigate();

    const dispatch = useDispatch();

    const deleteClickHandler = () => {
        navigate(location.pathname);

        dispatch(fetchDeleteVariable(state.id));
    };

    const cancelClickHandler = () => {
        navigate(location.pathname, { state });
    };

    return (
        <div className={CnDeleteVariable()}>
            <div className={CnDeleteVariable('header')}>
                <Title size="xs">Удалить переменную</Title>
                <Subtitle size="m">{state?.name}</Subtitle>
            </div>

            <div className={CnDeleteVariable('actions')}>
                <Button onClick={deleteClickHandler} view="primary" size="m">
                    Удалить
                </Button>

                <Button onClick={cancelClickHandler} view="secondary" size="m">
                    Отмена
                </Button>
            </div>
        </div>
    );
};
